import { grayLightest } from 'styles/css-constants';
import { MQ_SMALL_ONLY } from 'constants/mq';
import css from 'styled-jsx/css';

export default css`
  .StickyBanner {
    position: fixed;
    bottom: 0;
    width: 100%;
    background-color: ${grayLightest};
    display: none;
    transition: opacity 0.6s;
    z-index: 1000000000;
  }

  .StickyBanner__dismiss {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 1;
    padding: 0.5rem;
    outline: none;
    font-size: 15px;
  }

  .StickyBanner__content {
    margin: auto;
    width: 320px;
    height: 50px;
  }

  @media ${MQ_SMALL_ONLY} {
    .StickyBanner {
      display: block;
    }
  }
`;
